import { columnNamesType, OctTable, OctTablePagination } from "@oceantech/oceantech-ui";
import { FC, useContext, useEffect, useState } from "react";
import { toast } from "react-toastify";
import { AppContext } from "../appContext/AppContext";
import { ConfirmDialog } from "../component/ConfirmDialog";
import { CODE, DEFAULT_PAGE_INDEX, RESPONSE_MESSAGE, ROLE } from "../utils/Constant";
import { handlePagesChange, handleRowsPerPageChange, rowsForPage } from "../utils/PageUtils";
import { AssignmentImplementContext } from "./AssignmentImplementContext";
import AddAssignmentImplementDialog from "./components/AddAssignmentImplementDialog";
import Filter from "./components/Filter";
import { deleteAssignmentImplement, searchAssignmentImplement } from "./services/services";
import { hasAuthority } from "../utils/Permission";

export const OpenAssignmentImplement: FC = () => {

  const { setIsLoading } = useContext(AppContext);
  const { filter, setFilter, assignmentImplementList, setAssignmentImplementList } = useContext(AssignmentImplementContext);

  const [openDialogAdd, setOpenDialogAdd] = useState<boolean>(false);
  const [selectedRow, setSelectedRow] = useState<any>({});
  const [totalElements, setTotalElements] = useState<number>(0);
  const [rowsPerPage, setRowsPerPage] = useState<number>(10);
  const [page, setPage] = useState<number>(DEFAULT_PAGE_INDEX);
  const [openConfirmDialog, setOpenConfirmDialog] = useState<boolean>(false);
  const [isView, setIsView] = useState<boolean>(false);
 
  useEffect(() => {
    getAssignmentImplementList();
  }, [filter])

  useEffect(() => {
    setFilter({...filter, pageIndex: page, pageSize: rowsPerPage})
  }, [page, rowsPerPage])

  const getAssignmentImplementList = async () => {
    try {
      setIsLoading(true);
      let { data } = await searchAssignmentImplement(filter);
      if (data?.code === CODE.SUCCESS) {
        setAssignmentImplementList(data?.data?.content);
        setTotalElements(data?.data?.pageable?.totalElements);
        setIsLoading(false);
      } else {
        toast.error("Đã có lỗi xảy ra!");
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
      console.error(error);
    }
  }

  const handleYesClick = async (id: string) => {
    try {
      setIsLoading(true);
      let { data } = await deleteAssignmentImplement(id);
      if (data?.code === CODE.SUCCESS) {
        toast.success("Xóa thành công");
        setOpenConfirmDialog(false);
        getAssignmentImplementList();
      } else {
        toast.error(RESPONSE_MESSAGE.ERROR);
        setIsLoading(false);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  }

  const columns: columnNamesType[] = [
    {
      name: "STT",
      field: "stt",
      headerStyle: {
        width: "50px",
      },
      cellStyle: {
        textAlign: "center",
        color: "#333",
      },
      render: (row, index, stt) => {
        return <div>{(((Number(filter?.pageIndex) - 1) * Number(filter?.pageSize) + index) + 1)}</div>
      },
    },
    {
      name: "Ngày quyết định",
      field: "issueDate",
      headerStyle: {
        minWidth: "300px",
      },
      cellStyle: {
        textAlign: "center",
        color: "#333",
        width: "100px",
      },
    },
    {
      name: "Số quyết định",
      field: "decisionNumber",
      headerStyle: {
        minWidth: "300px",
      },
      cellStyle: {
        color: "#333",
      }
    },
    {
      name: "Năm thực hiện",
      field: "implementationEndYear",
      headerStyle: {
        minWidth: "300px",
      },
      cellStyle: {
        color: "#333",
      }
    },
    {
      name: "Thao tác",
      field: "action",
      headerStyle: {
        width: "150px",
      },
      cellStyle: {
        textAlign: "center",
      },
      render: (row, index, stt) => {
        return (
          <div className="flex justify-content-center align-items-center gap-4 px-4">
            <div
                onClick={() => {
                  setIsView(true);
                  setSelectedRow(row);
                  setOpenDialogAdd(true);
                }}
            >
              <span
                className="tooltips"
                data-tooltip="Chi tiết"
                data-tooltip-pos="left"
                data-tooltip-length="medium"
              >
                <i
                  className={`bi bi-eye-fill fs-2 text-pri`}
                ></i>
              </span>
            </div>
            {row?.canUpdate && (
              <div
                onClick={() => {
                  setIsView(false);
                  setSelectedRow(row);
                  setOpenDialogAdd(true);
                }}
              >
                <span
                  className="tooltips"
                  data-tooltip="Chỉnh sửa"
                  data-tooltip-pos="left"
                  data-tooltip-length="medium"
                >
                  <i
                    className={`bi bi-pencil-fill fs-2 text-pri`}
                  ></i>
                </span>
              </div>
            )}
            {row?.canDelete && (
              <div
                onClick={() => {
                  setOpenConfirmDialog(true);
                  setSelectedRow(row);
                }}
              >
                <span
                  className="tooltips"
                  data-tooltip="Xóa"
                  data-tooltip-pos="left"
                  data-tooltip-length="medium"
                >
                  <i
                    className={`bi bi-trash3 fs-2 text-pri`}
                  ></i>
                </span>
              </div>
            )}
          </div>
        );
      },
    },
  ];

  return (
    <div className="bg-white">
      <div className="spaces bg-gray radius-2">
        <div className="bg-white spaces width-100 flex justify-content-between p-10 border-bottom">
          <h4 className="text-title text-pri fw-bold fs-4 spaces mb-0">
            Danh sách quyết định giao thực hiện
          </h4>
        </div>
        <div className="d-flex justify-content-between align-items-center bg-white">
          <div className="flex-1">
            <Filter />
          </div>
          {!hasAuthority(ROLE.GIAM_DOC) && (
            <button
              type="button"
              onClick={() => {
                setIsView(false);
                setSelectedRow(null);
                setOpenDialogAdd(true);
              }}
              className="spaces min-w-90px btn btn-primary btn btn-primary mr-10"
            >
              <i className="bi bi-plus-lg text-white fs-3"></i>{""}
              Thêm
            </button>
          )}
        </div>
        <div className="d-flex flex-column spaces width-100">
          <div className="bg-white">
            <div className=" spaces bg-white m-0">
              <div className="bg-white spaces mb-6 pb-15 fl-1 ml-10 mr-10">
                <OctTable
                  id="ds-dot-dang-ky"
                  className="spaces dot-dang-ky-table"
                  columns={columns}
                  data={assignmentImplementList}
                  justFilter={false}
                  clearToolbar
                  noToolbar
                  noPagination
                />
                <OctTablePagination
                  handlePagesChange={handlePagesChange}
                  handleRowsPerPageChange={handleRowsPerPageChange}
                  page={page}
                  setPage={setPage}
                  rowsPerPage={rowsPerPage}
                  setRowsPerPage={setRowsPerPage}
                  totalPages={Math.ceil(totalElements/rowsPerPage)}
                  totalElements={totalElements}
                  rowsForPage={rowsForPage}
                  numberOfElements={0}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      {openDialogAdd && (
        <AddAssignmentImplementDialog
          onHide={() => {
            setOpenDialogAdd(false);
          }}
          onRefresh={getAssignmentImplementList}
          id={selectedRow?.id}
          isView={isView}
        />
      )}
      {openConfirmDialog && (
        <ConfirmDialog
          show={openConfirmDialog}
          yes="Xác nhận"
          onYesClick={() => handleYesClick(selectedRow?.id)}
          message={`Bạn có chắc muốn xóa quyết định này?`}
          close="Huỷ"
          onCloseClick={() => setOpenConfirmDialog(false)}
          title="Xác nhận thao tác"
        />
      )}
    </div>
  );
};

export default OpenAssignmentImplement;
